module.exports = __webpack_public_path__ + "static/media/mouse-cry.b53cec0d.png";